export enum FeesPeriodSearchKey {
  MONTHLY = 'monthly',
  QUARTERLY = 'quarterly',
  YEARLY = 'yearly',
  CUSTOM = 'custom',
}

export enum ExportFormatKey {
  CSV = 'csv',
  PDF = 'pdf',
  XLSX = 'xlsx',
}
